import React, { type ReactNode, Suspense, useEffect, useState } from 'react';
import useDrawer from 'components/generic/Drawer/hooks/useDrawer';
import { SIDE_MENU_ID } from './shared/constants';

const RootMenu = React.lazy(() => import('./components/Menu/RootMenu'));

export default function SideMenuOpener({ children }: { children?: ReactNode }): JSX.Element {
    const { isOpen } = useDrawer(SIDE_MENU_ID);
    const [hasOpened, setHasOpened] = useState(false);

    // Prefetch RootMenu chunk after page load
    useEffect(() => {
        import('./components/Menu/RootMenu');
    }, []);

    // Set true when the menu is opened for the first time
    useEffect(() => {
        if (isOpen && !hasOpened) {
            setHasOpened(true);
        }
    }, [isOpen, hasOpened]);

    return (
        <>
            {children}

            {hasOpened && (
                <Suspense fallback={null}>
                    {/* SideMenu gets mounted using React portal internally */}
                    <RootMenu />
                </Suspense>
            )}
        </>
    );
}
